<template>
    <div>
        <div class="topleft">
            <div class="logo" :style="logowid">
                <img :src="logourl" alt="" style="margin-top:-9px;">
            </div>
            <span class="closemenu" @click="changeMenu">
                <i :class="icon"></i>
            </span>
            <!-- <span class="closemenu" v-if="userInfo.user.roles[0].id == 1" @click="gotohome" style="border-left:none;">
                <i class="el-icon-s-home"></i>
            </span> -->
            <!-- <span class="closemenu" v-if="userInfo.user.roles[0].id == 1" @click="analyse" 
                style="border-left:none;">
                <i class="el-icon-share"></i>
            </span> -->
        </div>
        <div class="topright">
            <em>{{userInfo.user.nickName}}
                （{{userInfo.user.roles[0].name}}）  
                <!-- 地区：{{nt}}  时间：<span style="color: red;">{{timeArr|changedate}}</span> -->
            </em>
            <el-dropdown style="vertical-align: middle;">
                <span class="el-dropdown-link">
                    <el-avatar size="medium" src="/img/header.jpg"></el-avatar>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                        <el-popover placement="left-start" trigger="hover" :offset="15">
                        <template #reference>
                            <span>切换语言</span>
                        </template>
                        <el-menu mode="vertical" :default-active="$route.meta.route" router>
                            <el-dropdown-item @click.native="changeType('zh')">中文</el-dropdown-item>
                            <el-dropdown-item @click.native="changeType('en')">印尼语</el-dropdown-item>
                            <!-- <el-dropdown-item @click.native="changeType('es')">西班牙</el-dropdown-item> -->
                        </el-menu>
                        </el-popover>
                    </el-dropdown-item>
                    <!-- <el-dropdown-item v-if="userInfo.user.roles[0].id == 1">
                        <el-popover placement="left-start" trigger="hover" :offset="15">
                        <template #reference>
                            <span>切换地区</span>
                        </template>
                        <el-menu mode="vertical" :default-active="$route.meta.route" router>
                            <el-dropdown-item @click.native="changeNation('mx')">墨西哥</el-dropdown-item>
                            <el-dropdown-item @click.native="changeNation('pe')">秘鲁</el-dropdown-item>
                        </el-menu>
                        </el-popover>
                    </el-dropdown-item> -->
                    <el-dropdown-item @click.native="gotochange"><span>修改密码</span></el-dropdown-item>
                    <el-dropdown-item @click.native="logOut"><span >退出登录</span></el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>
<script>
import apiurl from "@/api/public"
import _api from "@/api/index"
export default {
    data(){
        return{
            isclose:false,
            icon:"el-icon-s-fold",
            userInfo:{},
            logowid:"width: 200px;",
            nt:"墨西哥",
            timeArr:null,
        }
    },
    props:{
        logourl:{
            type:String
        },
    },
    created(){
        let userInfo2 = JSON.parse(window.localStorage.getItem('userinfo'))
        this.userInfo = userInfo2

        if (userInfo2.user.roles[0].id != 1) {
            sessionStorage.setItem("nation", userInfo2.user.nation);
            localStorage.setItem("nation", "idr");
            if (userInfo2.user.nation == "pe") {
                this.nt = "印尼"
            }
        } else {
            var nation = localStorage.getItem("nation")
            if (nation == null) {
                sessionStorage.setItem("nation", "mx");
                localStorage.setItem("nation", "mx");
                this.nt = "印尼"
            }
            if (nation != null && nation == "pe") {
                this.nt = "印尼"
            }
        }

        var lang = localStorage.getItem("lang")
        if (lang == null) {
            this.changeType("es_US");
        }
        // setTimeout(() => {
        //     this.getHint()
        // }, 1000);

        setInterval(() => {
            this.fn()
        }, 1000); 
    },
    methods:{
        changeType(type) {
            this.$nextTick(() => {
                sessionStorage.setItem("locale", type);
                this.$i18n.locale = type;
                localStorage.setItem("lang", this.$t("lang"));
            });
            this.login();
        },
        changeNation(type){
            this.$nextTick(() => {
                sessionStorage.setItem("nation", type);
                localStorage.setItem("nation", type);
            });
            this.login();
        },
        login(){
            this.$alert(this.$t('login1'), this.$t('login2'), {
                confirmButtonText: this.$t('login3'),
                callback: action => {
                    this.$message({
                        type: 'info',
                        message: `action: ${ action }`
                    });
                    this.logOut()
                }
            });
        },
        gotochange(){
            this.$router.push("/changepass")
        },
        gotohome(){
            if (this.userInfo.user.roles[0].id == 1) {
                this.$router.push("/home")
            } else if (this.userInfo.user.roles[0].id == 3) {
                this.$router.push({path:"/mycall"})
            } else if (this.userInfo.user.roles[0].id == 5) {
                this.$router.push({path:"/usercheck"})
            } else if (this.userInfo.user.roles[0].id == 9) {
                this.$router.push({path:"/loan"})
            } else if (this.userInfo.user.roles[0].id == 18) {
                this.$router.push({path:"/userlist"})
            } else{
                this.$router.push({path:"/callorder"})
            }
        },
        analyse() {
            window.open('http://web.fastcredit.cloud/#/Tools');
        },
        changeMenu(){
            if(!this.isclose){
                this.$emit("getchange",true)
                this.icon="el-icon-s-unfold"
                this.isclose=true
                this.logowid="width: 68px;"
            }else{
                this.$emit("getchange",false)
                this.icon="el-icon-s-fold"
                this.isclose=false
                this.logowid="width: 200px;"
            }
        },
        userCenter(){},
        logOut(){
            _api.delete(apiurl.logout,{}).then(res=>{
                this.$notify.success({
                    title: this.$t('success'),
                    message: this.$t('login4')
                });
                this.$store.commit("cleartag","")
                localStorage.removeItem("menu")
                localStorage.removeItem("num")
                localStorage.removeItem("userinfo")
                localStorage.removeItem("token")
                this.$router.push("/login")
            }).catch(err=>{
                localStorage.clear()
                this.$router.push("/login")
            })
        },
        getHint(){
            _api.get(apiurl.getUserTime,{
                nation: localStorage.getItem("nation"),
            }).then(res => {
                    this.$alert('app已经有：' + res.data + '分钟没有新增用户了', {
                    confirmButtonText: '确定',
                    callback: action => {
                        this.$message({
                            type: 'info',
                            message: `action: ${ action }`
                        });
                    }
                });
            })
        },

        fn(){
            var date = new Date();
            var UTCTime = Date.now() + date.getTimezoneOffset() * 60 * 1000;
            if (this.nt == "印尼") {
                this.timeArr = UTCTime - 6 * 60 * 60 * 1000;
            } else {
                this.timeArr = UTCTime - 5 * 60 * 60 * 1000;
            }
        } 
    }
}
</script>
<style scoped>
.topleft{ float: left; padding-top: 0px;}
.closemenu{ display: inline-block; padding-top: 4px; width: 50px; height:50px; cursor: pointer; text-align: center; line-height: 50px; border-left: rgba(255,255,255,0.1) solid 1px;border-right: rgba(255,255,255,0.1) solid 1px;}
.closemenu i{ font-size: 20px; color: #ffffff;}
.topright{ float: right; padding-top: 7px;}
.topright em{font-size: 14px; font-style: normal; vertical-align: middle; margin-right:15px; color: #ffffff;}
.logo{display: inline-block; text-align:center; cursor: pointer; height: 50px; position: relative; z-index: 3000; color: #ffffff; line-height: 50px; font-size: 18px;}
</style>